import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import styles from "./COATitle1.module.scss";

const Title1 = ({ children, sx = {} }) => (
  <Box className={styles.title1} sx={sx}>
    {children}
  </Box>
);

Title1.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

export default Title1;
